import { Alert, Button, Card, LinkButton, LoadingState } from '../ui';

export default function InvitationJoinStatus({state, retry, dismiss}) {
  if (!state) return null;
  const {phase, competition, entry, action} = state;
  return <Card as="section" padding="standard" className="mb-6" aria-label="Competition invitation">
    {phase === 'joining' ? <>
      <h2 className="fc-heading-3">{competition ? `Joining ${competition.name}` : 'Checking your invitation'}</h2>
      <LoadingState label="Please wait while we confirm your entry. You can continue when this finishes." />
    </> : phase === 'error' ? <>
      <Alert tone="danger" title={competition ? `Unable to join ${competition.name}` : 'Unable to join competition'}>{state.message}</Alert>
      <div className="flex flex-wrap gap-3 mt-4">
        {state.retryable && <Button onClick={retry}>Try again</Button>}
        <Button variant="secondary" onClick={dismiss}>Dismiss invitation</Button>
      </div>
    </> : <>
      <Alert tone={entry.status === 'active' ? 'success' : 'info'} title={entry.status === 'pending' ? `Request sent to ${competition.name}` : entry.status === 'active' ? `You've joined ${competition.name}` : `Your entry in ${competition.name}`}>
        {entry.status === 'pending' ? 'Your entry is awaiting organiser approval. You can view the competition while you wait.' : entry.status === 'active' ? 'Your membership is confirmed. Open your entry to check the current selection window.' : 'View the competition to check your entry status.'}
      </Alert>
      <div className="flex flex-wrap gap-3 mt-4">
        <LinkButton to={action.to}>{action.label}</LinkButton>
        <Button variant="secondary" onClick={dismiss}>Dismiss</Button>
      </div>
    </>}
  </Card>;
}
